import { Lookup } from "./Lookup"
import { MasterExerciseLookup, MasterWorkoutExercise } from "./MasterWorkoutExercise"

export interface MasterWorkout {
	id: number
	name: string
	previousName?: string
	description: string
	permalink: string
	weeks: number
	daysPerWeek: string
	thumbnailId: number
	thumbnailUrl: string
	enableMains: boolean
	enableMainAlts: boolean
	enableRetest: boolean
	enableRepsPerSet: boolean
	enableRirPerSet: boolean
	retestWeekDuration?: number
	tags: string[]
	weightSelection: string
	programType: string
	difficultyRating: number
	workoutType: string[]
	sessionTime: string
	focusedMuscleGroups: string[]
	author: MasterWorkoutAuthor
	authorId: number
	isNew: boolean
	isPublic: boolean,
	createdBy: number,
	searchKeywords: string,
	masterWorkoutMaxes?: MasterWorkoutMax[]
	publishedDate: Date
}

export interface MasterWorkoutListItem {
	id: number
	name: string
	weeks: number
	daysPerWeek: number
	thumbnailUrl: string
	tags: string[]
	permalink: string
	difficultyRating: number
	isNew: boolean
	isPublic: boolean
	createdBy: number
}

export interface MasterWorkoutMax {
	id: number
	masterExerciseId: number
	groupTermIds?: number[]
}

export interface MasterWorkoutMaxOption {
	masterExerciseId: number
	name: string
}

export interface MasterWorkoutAuthor {
    id: number
	name: string
	image: string
	url: string
}

export interface Api_GetMasterWorkoutsRequest {
	pageNum: number
	searchText?: string
    difficultyRating?: string[]
	weightSelection?: string[]
	workoutType?: string[]
	focusedMuscleGroups?: string[]
	daysPerWeek?: string[]
	sessionTime?: string[]
	tags?: string[]
}

export interface API_GetMasterWorkoutsResponse {
	totalCount: number
	currentCount: number
	totalPages: number
	currentPage: number
	data: MasterWorkoutListItem[]
}

export interface API_ImportMasterWorkoutRequest {
	masterWorkout: MasterWorkout
	masterWorkoutExercises: MasterWorkoutExercise[]
}

export interface MasterWorkoutLookups {
	authors: Lookup[]
	weightSelections: Lookup[]
	tags: Lookup[]
	workoutTypes: Lookup[]
	focusedMuscleGroups: Lookup[]
	sessionTimes: Lookup[]
	masterExercises: MasterExerciseLookup[]
	groupTerms: Lookup[]
	programTypes: Lookup[]
	difficultyRatings: string[]
}

export interface MasterWorkoutValidationResponse {
	canBeImported: boolean
	messages: string
}

export const programTypes: Lookup[] = [
	{
		name: 'Default',
		value: 'default'
	},
	{
		name: 'Cardio',
		value: 'cardio'
	},
	{
		name: 'Circuit',
		value: 'circuit'
	}
]

export enum MasterWorkoutTabs {
	details = 0,
	exercises = 1
}